import styled from '@emotion/styled'
import { Flex } from 'rebass'
import { useMediaQuery } from 'react-responsive'

import ResultAnnounceMobile from './ResultAnnounceMobile'
import ResultAnnounceDesktop from './ResultAnnounceDesktop'

const ComputerChoseContainer = styled(Flex)`
  width: 600px;
  display: flex;
  justify-content: space-around;
  flex-direction: column;
  @media (max-width: 1366px) {
    height: 100%;
  }
`

const ResultAnnounce = (props) => {
  const isSmallScreen = useMediaQuery({
    query: '(max-width: 1366px)'
  })
  return (
    <ComputerChoseContainer>
      {isSmallScreen ? <ResultAnnounceMobile {...props} /> : <ResultAnnounceDesktop {...props} />}
    </ComputerChoseContainer>
  )
}

export default ResultAnnounce
